import React, { Component } from 'react';
import NewEvent from '../NewEvent/index';

class Preview extends Component {
    constructor() {
        super();
        this.state;
    }

    render() {
        return(
            <NewEvent isPreview={true} match={this.props.match} history={this.props.history} />
        )
    }
}

export default Preview;